import * as forms from './all';
import { Const, FormMapConfig } from '../shared';

// Tipos de tarea
const type = Const.TYPES_TASK;

// Tipo de tarea con sus respectivos formularios
export const formMappings: FormMapConfig = {
  // Ninguno
  [type.none]: {
    index: {
      component: forms.NoneFormComponent,
      config: {
        renderIn: 'modal'
      }
    }
  },
  // Condición
  [type.condition]: {
    index: {
      component: forms.ConditionFormComponent,
      config: {
        renderIn: 'modal'
      }
    }
  },
  // Asignación
  [type.assignment]: {
    index: {
      component: forms.AssignmentFormComponent,
      config: {
        renderIn: 'view'
      }
    }
  },
  // Forma especifica
  [type.form]: {
    example_docs: {
      component: forms.ExampleDocsComponent,
      config: {
        renderIn: 'view'
      }
    },
    elaborar: {
      component: forms.ElaborateComponent,
      config: {
        renderIn: 'view'
      }
    },
    aprobar_firmar: {
      component: forms.ApproveComponent,
      config: {
        renderIn: 'view'
      }
    },
    radicar: {
      component: forms.RadicationComponent,
      config: {
        renderIn: 'view'
      }
    },
    determinar_liquidacion: {
      component: forms.LiquidationDeterminationComponent,
      config: {
        renderIn: 'view'
      }
    },
    proyectar_liquidacion: {
      component: forms.ProjectLiquidationComponent,
      config: {
        renderIn: 'view'
      }
    },
    instance_liquidacion: {
      component: forms.InstanceLiquidationComponent,
      config: {
        renderIn: 'view'
      }
    },
    anexos: {
      component: forms.AttachedComponent,
      config: {
        renderIn: 'view'
      }
    },
    publicacion: {
      component: forms.PublicationComponent,
      config: {
        renderIn: 'modal'
      }
    },
    dynamic_form: {
      component: forms.DynamicFormsComponent,
      config: {
        renderIn: 'view'
      }
    },
    inventario_documental_ac: {
      component: forms.DocumentInventoryFormComponent,
      config: {
        renderIn: 'view'
      }
    },
    inventario_expediente_documental_ac: {
      component: forms.DocumentExpInventoryFormComponent,
      config: {
        renderIn: 'view'
      }
    },
    modificar_documento: {
      component: forms.ModifyDocumentInstanceComponent,
      config: {
        renderIn: 'view'
      }
    },
    aprobar_modificacion_documento: {
      component: forms.ApproveModifyDocumentComponent,
      config: {
        renderIn: 'view'
      }
    },
    
  }
};



// WEBPACK FOOTER //
// ./src/app/forms/forms-mappings.ts